import { DeleteOutlineIcon } from '@carboncopyco/icons';
import { ConfirmAlert } from '@carboncopyco/ui';
import ModalWrapper from '../Modals/ModalWrapper';

export interface IConfirmExitAlertProps {
  isOpen: boolean;
  onClose: () => void;
  onExit: () => void;
  title: string;
  description: string;
  yesLabel: string;
}

export const ConfirmExitAlert = ({
  isOpen,
  onClose,
  onExit,
  title,
  description,
  yesLabel,
}: IConfirmExitAlertProps) => (
  <ModalWrapper
    isVisible={isOpen}
    onCloseModal={onClose}
  >
    <ConfirmAlert
      containerClass="w-ds-500"
      show={isOpen}
      onConfirm={() => {
        onClose();
        onExit();
      }}
      noLabel="Cancel"
      danger
      description={description}
      onClose={onClose}
      title={title}
      yesIcon={<DeleteOutlineIcon />}
      yesLabel={yesLabel}
    />
  </ModalWrapper>
);
